import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Activity, Gauge, Brain, BarChart3 } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import SlaUptimePage from '@/pages/SlaUptimePage';
import RiskPipelineMonitor from '@/components/analytics/RiskPipelineMonitor';
import RkgGovernancePage from '@/pages/empreendimentos/RkgGovernancePage';
import UxAdoptionMetricsPanel from '@/components/empreendimentos/UxAdoptionMetricsPanel';

const ObservabilidadePage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'sla-uptime';

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value }, { replace: true });
  };

  return (
    <div className="h-full flex flex-col gap-4 overflow-auto">
      <Tabs value={defaultTab} onValueChange={handleTabChange} className="flex-1 flex flex-col min-h-0">
        <TabsList className="self-start">
          <TabsTrigger value="sla-uptime" className="gap-2 text-xs sm:text-sm">
            <Activity className="h-4 w-4" />
            SLA & Uptime
          </TabsTrigger>
          <TabsTrigger value="pipeline" className="gap-2 text-xs sm:text-sm">
            <Gauge className="h-4 w-4" />
            Monitor de Pipeline
          </TabsTrigger>
          <TabsTrigger value="rkg" className="gap-2 text-xs sm:text-sm">
            <Brain className="h-4 w-4" />
            Governança RKG
          </TabsTrigger>
          <TabsTrigger value="ux-adoption" className="gap-2 text-xs sm:text-sm">
            <BarChart3 className="h-4 w-4" />
            Adoção UX
          </TabsTrigger>
        </TabsList>

        <TabsContent value="sla-uptime" className="flex-1 min-h-0 mt-4">
          <SlaUptimePage embedded />
        </TabsContent>

        <TabsContent value="pipeline" className="flex-1 min-h-0 mt-4">
          <RiskPipelineMonitor />
        </TabsContent>

        <TabsContent value="rkg" className="flex-1 min-h-0 mt-4">
          <RkgGovernancePage embedded />
        </TabsContent>

        <TabsContent value="ux-adoption" className="flex-1 min-h-0 mt-4">
          <UxAdoptionMetricsPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ObservabilidadePage;
